import { Injectable } from '@angular/core';
import { JSONValue } from '@models';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: string, value: JSONValue): void {
    localStorage.setItem(key, value?.toString() ?? '');
  }

  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
